import { getItems } from "../../../services/scheduling/item";

export default {
    namespaced: true,
    state: {
        items: [],
    },
    getters: {
        items: state => state.items,
    },
    mutations: {
        setItems: (state, payload) => state.items = payload
    },
    actions: {
        fetchItems(context) {
            return new Promise((resolve, reject) => {
                getItems({scope: "all"})
                    .then(response => {
                        context.commit("setItems", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        },
    }
}